import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'WorldLayout28',
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_1',
      parent: '2',
      data: ''
    },
    {
      id: '7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_2',
      parent: '2',
      data: ''
    },
    {
      id: '8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_3',
      parent: '2',
      data: ''
    },
    {
      id: 'ff025e88-392c-496e-a6ce-64c68763f7fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_4',
      parent: '2',
      data: ''
    },
    {
      id: '8ffd2fc1-7520-4935-9693-6e2403a658da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_5',
      parent: '2',
      data: ''
    },
    {
      id: 'd54e5b9d-386a-4307-b1a9-6be39a00a83d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_6',
      parent: '2',
      data: ''
    },
    {
      id: '808a13aa-845c-4b5e-aeef-1b567423be8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_7',
      parent: '2',
      data: ''
    },
    {
      id: '6a4051d9-8e06-4304-aebc-8e6449aa8b8a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map28_export_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 292,
      y: 433,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cfc191e5-de8a-4d31-a9e5-4acd1efd8ee4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 382,
      y: 451,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bc5fc7ca-9fee-4b06-8282-f06da2a7558c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 441,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ffe93f63-1d88-4670-8c40-405ce0801a88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 518,
      y: 559,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '343ff901-a19d-462b-9c7d-dfdd00b43956',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 611,
      y: 555,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '539bd34c-d88d-44e7-8493-d0cc21ae63ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 662,
      y: 487,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f77810e6-97d4-4c6c-8433-bdd5aaca1051',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 752,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '759cdf8e-ee7c-4056-97a4-9c125d95f2a1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 843,
      y: 490,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '17af076b-edab-41a5-a687-af63bb786c48',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 908,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd08cff26-fd82-4290-a72c-fb334139f8a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 920,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b373e88-c863-4d38-86f6-3aefaf1ebbd7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 999,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0624709d-8421-4821-82d6-0f6065cf17eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1090,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6fbe7647-bb86-40a1-9053-46bb27233afe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1175,
      y: 334,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e4a115c2-a6dc-460d-bbfd-2de34276ff14',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1231,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5e9a66cb-3bac-416c-975f-4d6a8557fe2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1317,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '27c2792d-f54e-4a0f-b5f1-af71eb04d64a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1402,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2dd0ff09-5dec-480e-b50c-ae4ee1506db8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1481,
      y: 336,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f99216df-8229-4ec2-92ad-fdf9fc4aae29',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1575,
      y: 320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '67630334-3600-4d49-aa4c-d36a1dfa9acc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1668,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b86cacda-083c-4f2c-9c44-d70550a11386',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1760,
      y: 268,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1d0d83c5-5104-4ecc-baa3-3da65e8e0cf0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1845,
      y: 221,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fff0a84e-42c0-4899-9331-fd3a8846016d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1945,
      y: 197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd0f7b026-4418-4d26-a143-15a4740d99a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2044,
      y: 208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '11102cb8-ed98-4dde-8754-14f16e82d4da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2136,
      y: 239,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '30d71e6a-10f4-4acd-859a-1decc5b33c71',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2214,
      y: 309,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '73ebfdb8-8b9e-4ea6-91b8-4db1a78b8ef2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2262,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ff8d2101-a743-4d45-8ec5-4d68295a260a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2363,
      y: 460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2beb6f56-ef33-4440-8237-a4a308f4df40',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2485,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '17bef134-3967-48c3-8765-d7ef4c5d1563',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2572,
      y: 408,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '579e7e97-5bee-48e4-a3f1-1dde8fde961b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2658,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '236e0533-5bb5-4019-b60a-284bf782bcde',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2737,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ee6c20b7-a274-48c6-9e3d-0c9f0b1666b6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2831,
      y: 242,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2b566c7c-83d5-4072-97ce-9e165ad66798',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2929,
      y: 215,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3bf88eb8-1024-4f4a-b4f2-fbd1b1a77438',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3028,
      y: 193,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e27c2c2e-3bd1-4d0b-a4be-d7be4b19d7ef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3128,
      y: 210,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '53e5c3ad-c7cb-402e-97d1-c00a319b224c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3222,
      y: 249,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '57613fe9-25fa-496d-8cdc-2702117250f8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3311,
      y: 291,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '06e69255-b181-4d01-ac59-43eec190dc29',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3410,
      y: 320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '550b6756-f51c-4048-aafb-fc564a3f0b9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3497,
      y: 369,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '26bda3de-9d2b-47bb-aaa9-5d2ef787ee3c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3569,
      y: 435,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c9639af2-81dc-4783-9779-a8e7609c1b24',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3656,
      y: 482,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2de6a41e-598b-4a01-be6b-cb2941243269',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3750,
      y: 519,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fe765bdd-e929-4081-bdfe-e4c2a608e7e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3844,
      y: 546,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd3c4fbee-ef3b-46cf-9393-a9823199e141',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3949,
      y: 530,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '99b30018-8449-49a4-b8e8-e5230c1a06e5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4006,
      y: 460,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4c0865b3-b5b4-4cf7-93bc-b320d379c05f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4103,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '166557bd-3d8b-434f-91ce-5d289974a96d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4176,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ea5a0e36-21ce-4f84-9be7-aaa137c63903',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4240,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6e1e65da-eaf9-4ea6-973d-b99a5c4b3bc7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4324,
      y: 235,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c2da5700-72c9-4f0e-98ba-86a6602746a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4412,
      y: 195,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd4c7bbc3-1c24-4caa-90c0-630aedba668f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4510,
      y: 180,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bf015ebe-4c14-469d-a5c8-3e391b0aa4ff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4607,
      y: 191,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '07dcf4ab-2b96-465c-97fd-7754dac696f7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4708,
      y: 208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2c31c60c-6329-4c88-a8f6-0e3ddfc456e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4807,
      y: 228,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0824e677-64f1-409a-8dbf-fd27e20415c6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4873,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '11502b99-0fe5-4f5f-8a41-6211682bda3f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4933,
      y: 363,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c64db84e-de83-448f-bb5f-451264499510',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5001,
      y: 435,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '78dbcd46-b502-4dc4-8bc8-8776ef323bff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5100,
      y: 484,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '972635e1-ea38-4265-9785-00567d774520',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5213,
      y: 491,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b5ad3a5b-6bad-43b2-b440-cc0ca47e9351',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5330,
      y: 487,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a9f58018-7fa5-4162-9070-2fac008fe936',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5435,
      y: 486,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '93f03aca-7595-4675-8304-e5e4ec210840',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5531,
      y: 520,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c22e132b-a04f-4845-9c43-db9156c3d2f4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5623,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8f736a9b-04e8-4b19-8f26-377c509838e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5688,
      y: 414,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '770c1c62-2480-4d2c-a172-6542c5034a9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5756,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e7fb9556-71f3-4da8-8ae6-26f34b81a6cb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5830,
      y: 290,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1b2bde7f-cda2-49e9-8d10-b8245bb6f5a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5914,
      y: 239,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd22ce010-7675-4f1b-97d0-94ee37ed5408',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6014,
      y: 221,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8c9c5b15-8c09-4ea8-988b-1b1d0f3f21a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6112,
      y: 228,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4a076b49-ecd0-419a-9e71-ece647a8ea7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6209,
      y: 251,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bc2549c9-97cd-4a34-9554-7e221e87d245',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6297,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3258d25f-7714-4970-bc29-451b151be4f1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6386,
      y: 346,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7642d847-0d62-4127-ba6e-046658d57376',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6492,
      y: 374,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '34a53950-d3fd-4952-a3b8-5ed97fa40432',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6595,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '418859b1-b0c9-4fb4-92e0-778dae41e9a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6695,
      y: 459,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e18ad18c-18fe-4bf8-b234-903212440c9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6786,
      y: 540,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e234ecf8-d30b-4991-9eab-8865251a5e3f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6872,
      y: 595,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c678ff27-7f5c-4bef-8bcd-cf6068136549',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6972,
      y: 609,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '485f99da-642a-4a98-855a-b5178095e6e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7068,
      y: 602,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '33f0d1a3-4064-4413-a6c3-5a78dc302a1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7160,
      y: 575,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c121b964-44bc-40db-8eda-2bd74d630a20',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7251,
      y: 540,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '41e28c3f-4be6-4a0d-bd91-f6a1d4ffabf1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7331,
      y: 491,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4ae3bcf8-a694-4965-9d59-719334333771',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7405,
      y: 434,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f9df12ff-6387-4bab-a4d6-7587daec7925',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7490,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '96b5be6f-0009-437c-bc2e-ee07ec5cde2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7578,
      y: 353,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b17e92b6-7dfb-446e-8863-865e5f733c37',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7671,
      y: 323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a940d3e9-02a6-49c6-9054-3f130c936b16',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7762,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c3a80f1a-c42e-454d-8853-991c780b7e36',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7858,
      y: 293,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ff2854b4-9648-45b9-869f-b081c35f8199',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7956,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8d80acf0-7ae5-4c39-9ab5-25b557126a7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8053,
      y: 295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2e9307b3-2973-4ac4-afc8-122fa521eed0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8164,
      y: 321,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd535c4d5-92ce-4b3b-a071-67a762279692',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8243,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fc82c088-3cc2-4a02-96a8-744c4719062b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8266,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'feb00573-f302-4161-9252-7e779315cbcf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8341,
      y: 547,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cd546056-e6d3-4ec9-84fa-ce728419dbd1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8449,
      y: 573,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '41a87d06-31ac-4e9c-8f13-fadc023474d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8561,
      y: 576,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f5841f4a-b706-43db-a9ed-75f0642b29db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8673,
      y: 556,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1a17bfde-bd90-494f-a352-84727777f2ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8774,
      y: 540,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6e52b961-6c59-45c1-af96-fc4bba231de1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8868,
      y: 496,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9dd03e5f-4cf7-4f4e-b7e4-0ed3722efc86',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8901,
      y: 416,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cce53f4c-946e-4bb7-a9dd-0e7234de3d50',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8953,
      y: 338,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '55f4ff03-5429-42d6-813e-65e71acadd2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9036,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1a2260f5-5122-4f5e-b39e-8d2a73c9fb3d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9131,
      y: 265,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4ce804ef-3911-4fee-9ac6-02781410b554',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9236,
      y: 255,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3e379207-b55d-4d44-a1e6-e5f9d77f88b6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9336,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b00147f1-6dbd-4c6d-947a-447e49a1e868',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9425,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '89e76948-a530-41fb-b8b3-48d5dbdeebda',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9486,
      y: 379,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fab7a836-3dd4-48f2-a596-524dae2a3397',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9550,
      y: 445,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6323b6e9-f8a5-4ed1-8765-ec8d9c821357',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9632,
      y: 497,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bfb65a36-a49e-48fd-8f28-71d5e7dfbea9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9719,
      y: 539,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '16e427cd-a8f9-4072-9628-98a2b3f92cfb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9816,
      y: 553,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4ace8f72-db5c-4911-9b63-51a56e7072dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9912,
      y: 560,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8ded8ed6-f466-49c2-8a0e-d32326a5eb5d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10007,
      y: 586,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2267a19d-670e-415f-ab32-95c5c5bde127',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10109,
      y: 603,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '84dc0907-eb7c-4a97-b16b-f5075044d391',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10197,
      y: 566,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '75373a2f-46b3-4ad2-9c1a-7826ba5831bc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10288,
      y: 536,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e00425f6-b299-4e03-ad16-23e4dfd21007',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10378,
      y: 502,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '954958b1-dce2-4ffd-bd22-ab2eb3f27479',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10463,
      y: 466,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9311190a-103e-42f3-9dff-ceb3625dbce1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10555,
      y: 434,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7ef65a48-c988-42c8-af59-e52fc441bd23',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10648,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '631194d4-ad73-4366-a65f-21797e8dc249',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'af38acd5-a0e4-43d7-856f-fef8f3b120a3',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '74092e03-0544-42a0-a499-3278f19873a5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '583acaed-3914-470b-a17f-69f0e67d92ab',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'ea7f8b33-ad80-48d6-98f7-0540c1ec4100',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '214ea0e2-d913-4c42-a718-1f4bc72d2b79',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '82630176-2990-4416-9aea-7563d486a8a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 199,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '347d8c50-6e0f-4607-aba2-b7ce3d69ebac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 148,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c3d7d2da-25e3-44df-8abc-28e42a8a260b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 96,
      y: 764,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '39a0eccf-2c5f-4216-a563-bd337361fcd7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 381,
      y: 645,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '5bc54630-03b8-41b6-a6f4-1ca6459da132',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 321,
      y: 693,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f88668b5-0338-4124-aadd-ea64db59225a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 257,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '766ddc48-862e-40c3-850c-bb716057b225',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 204,
      y: 779,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '09c078fa-72a7-4925-b335-b55a11c14bc4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 499,
      y: 679,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '97e9bc30-63d7-4178-99c7-41494487d19a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 433,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '6ab8424a-07d0-4b6b-a27b-7959b9769f93',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 376,
      y: 768,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '2baa7a90-d750-449f-9f33-b4450f353b83',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 591,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '135ccde0-c8a0-474f-b243-a70157e38201',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 525,
      y: 778,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'bfdcda4a-93c9-4992-bfb7-e85a17616946',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 652,
      y: 769,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '4ac4e88c-1dff-4aeb-942d-1934649f67bc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1114,
      y: 511,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f617d86a-00ba-4b35-ac54-45f5eb0ec404',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1037,
      y: 553,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '8f3f548e-744e-41e9-a0c9-2bd8ed67895f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 965,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'cb7a07a3-03c8-45c3-99bc-20042842e639',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 901,
      y: 638,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '68ba511e-c1c4-4bf3-bd8f-48c1fd0a2f7f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1223,
      y: 533,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '355f7916-7550-4aec-ad28-6ccadc57016c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1142,
      y: 573,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '8d6cccac-8106-43d7-9f6d-2d861928531a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1064,
      y: 614,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '423432a7-e097-4b52-a5c4-2805b42cd11e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 999,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'efe5d952-d93d-4ac1-af58-93c0dc58757b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 938,
      y: 709,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c3c5cb31-3c0c-4d79-96b9-14401d1b1c39',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1380,
      y: 558,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'cbd1af5c-5708-44ad-8baa-73d3428699b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1305,
      y: 591,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ba25954f-4229-4d16-8d5a-6aad5d79a4f6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1235,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '70aa29b2-b8ca-4bb8-80ab-bfc3488df321',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1164,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '3e5bd705-7c79-42a3-9769-5067c3bf4540',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1094,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b5ca1ae4-ceab-4276-90ba-b9938cb1dd79',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1027,
      y: 756,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '6aef6b4b-d407-4cfe-a64b-e77cf37e6970',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1492,
      y: 605,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'af3f1fb5-7be3-4f9d-9538-1ce8c33e2714',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1418,
      y: 640,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fe931930-b8d9-4344-9080-7fefc325054c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1352,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'cc3d5e73-e23e-4f02-a898-d6ef91fc792a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1281,
      y: 716,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fd5901e9-a15f-45b1-89a0-a3e9af482d1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1217,
      y: 759,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c383030d-eaf1-402e-99c9-cb4f366e4b77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1524,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a21807b3-f9fd-4c21-8272-45b5a8b28ca0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1446,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ad85e363-c3bf-49bd-8bb7-b1ba26852a74',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1384,
      y: 766,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '5457ed12-1636-4820-8eee-ac711aeefcd4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1629,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f0a6c723-2143-44e0-94bc-e41de2266426',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1556,
      y: 769,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a275a188-5492-4632-b77c-b28569e63a82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 663,
      y: 94,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '1f2eb758-88bf-468c-8597-2aa4f749712e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 707,
      y: 159,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '42ab0570-a1a6-4b1c-9e2f-f963aad2cbd4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 753,
      y: 229,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '7b599ca2-0ec5-4bad-bb0f-212c7f34bae1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 791,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '5e18d8b6-298f-4faf-9e03-035cc14d5f5d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 771,
      y: 82,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '60724339-74e8-4c3e-85d5-8a7b5dd3e809',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 828,
      y: 145,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b575f4d4-7ade-40f9-95ca-cbea07fbb74d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 878,
      y: 200,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b638135d-84f0-4cf1-b266-7c84608f151c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 834,
      y: 15,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '93bd050f-0392-4901-8350-42db613aea0b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 892,
      y: 69,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '8e243039-8778-4039-8853-00cec8d29678',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 940,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '27eb3860-07a9-48d9-bce3-1a6146fba0b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 986,
      y: 186,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '0becc1cf-b528-4546-8e97-2721f3224c64',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1038,
      y: 245,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a182068c-b8c9-4455-8046-7e75ca7846a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 929,
      y: 259,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '54f682a5-4a3c-42e4-968f-29996c3c5576',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 978,
      y: 23,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '0ecd5d54-c277-41c1-b58e-d6610dca38a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1027,
      y: 83,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '5d815aeb-21b4-4eb4-b7d0-7095feb68fd6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1081,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a5ec4caa-ed43-45b4-b12b-6c12e36a4bcb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1130,
      y: 226,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '394e595e-1dab-42ef-a3c6-2bae92455cf5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1109,
      y: 23,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '292f668e-bdca-4345-aacf-13c174c0369b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1149,
      y: 85,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '3fca8d9d-b007-4d9a-9c56-f99743725e9b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1191,
      y: 147,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fb4b37c7-3850-435d-8b08-9047ddd2d346',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1233,
      y: 204,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fdc1efce-589a-4785-8ca5-45e41d3d8e38',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1237,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b705c519-a6a0-404b-9034-5a53e241f15d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1288,
      y: 128,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '44c1582a-31cc-480d-9bbb-403aa3000b92',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1375,
      y: 113,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '96ffae59-75b1-4da6-9b07-764016866c47',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1334,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f3d66f62-9f91-4e5c-84a6-5058796bd3e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1332,
      y: 197,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '74',
      data: ''
    },
    {
      id: '263cd568-88ac-4fbe-a6f4-f00adb3eb745',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2196,
      y: 671,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '0f48f4e0-5857-4519-95b9-12326ca79071',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2260,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f5028758-96d2-4b4c-8249-f7a35af2d8e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2325,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '6df46ea4-dae7-4b59-a42b-2b7c3da81a0f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2371,
      y: 770,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b7c6d704-f242-4f37-8691-553edad0f5c3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2438,
      y: 718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'e89090b9-12ca-491d-b9c3-95d7216cf274',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2504,
      y: 781,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ef66a593-e260-4405-8f35-4a2e4bbeab2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2673,
      y: 777,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '81c631a3-fc80-4d20-9959-0f1d126e28f7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2317,
      y: 217,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b1916aac-6a4e-4955-b26f-a92d39398cd6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2343,
      y: 150,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c7d6e02a-3f06-4fca-9b12-4cd5ac84b4a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2441,
      y: 112,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '4b029e29-fd3d-458a-b295-6f8f8b4ea005',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2489,
      y: 56,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'cdf5c7e1-b4e6-4264-96ad-058dc44644bb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1805,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '71385148-84de-46cd-b08d-a8d7e5dd2763',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1915,
      y: 24,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '0391cf4c-c0d6-42b5-b0f3-ff17158df7a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2032,
      y: 15,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ae4ce0fc-9fd4-4a72-871d-44bc4e8a88e6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2166,
      y: 23,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '38a06b6b-1320-43ae-9d7c-0fad61582042',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2088,
      y: 64,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f8fa88d9-d247-456d-a898-6a1b52b5c9c3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1985,
      y: 67,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'cc873de6-472a-4e49-a1ff-a175281f1b2d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1886,
      y: 96,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '877c64c5-8862-4800-b668-a9abc256bbcf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2556,
      y: 87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'fed7a6b7-c889-416a-b18d-9b33959d7b02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2621,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ef353a7a-46b1-4705-ad8b-3764261eac9d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2690,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '4c6e2e2e-2621-4503-9653-a2adf234d332',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2525,
      y: 157,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '8dc1d438-df60-4bc3-9282-4d807e95ce52',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2603,
      y: 196,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ece3608f-a398-43c5-b417-5f38664e47d2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2425,
      y: 196,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '57475322-ad2c-4377-b39f-ab3811acf9d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2493,
      y: 229,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '81bc3c73-42d7-4afd-9804-ab9556548f28',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2571,
      y: 277,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '0b43b41d-38c8-4792-8429-c634dfc6d170',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2472,
      y: 300,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f6a114e6-a512-4716-99ef-b126ef924e32',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2392,
      y: 261,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'be567ef5-4f13-4125-8e7c-954fea7d49a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2567,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '67f5c925-c620-404d-b3e1-72b2742b4bfc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2198,
      y: 785,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ebd3fed7-82b0-493c-b3eb-f1b58de44532',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2132,
      y: 709,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '3eb55077-c3b9-4216-87c5-0ec4a6c70a9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2069,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c367e887-07d4-4fd0-8ea8-6e4059ce97a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2057,
      y: 669,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_4',
      parent: '110',
      data: ''
    },
    {
      id: '9fa497c3-0662-40f8-924a-343ab27bb2ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3101,
      y: 400,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'fe0030f7-1270-4aa6-9541-4a358b8da4b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3006,
      y: 434,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '8ac6a68b-a928-4075-b62e-d36a2b4db138',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2917,
      y: 480,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'a3cde0ad-171b-4c3c-8183-32c898d06adb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3211,
      y: 443,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9907c1f8-5c2a-47bc-aec9-c8383aeb1eba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3121,
      y: 493,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'd78219e4-35d4-484d-a09b-eb53096e787c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3018,
      y: 507,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'fa9fd8d0-3148-4ca6-96f7-373047d1d9db',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2940,
      y: 560,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'a62a14a1-f129-475b-b4cd-531911fe9dd9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3353,
      y: 486,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'aaa487b7-be11-4759-b08e-63da55409a80',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3271,
      y: 536,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'bc194216-8a4b-4671-8841-ac635a4891fa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3168,
      y: 550,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '4f440bcd-1718-442a-bee6-e7e9738e68c0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3473,
      y: 548,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '55464168-52ad-4b00-bcbe-767755603d73',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3376,
      y: 569,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '548a96d4-085b-4e68-a6dd-1289f2a3f28d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3270,
      y: 616,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'ae57d9b2-ac13-4f5f-86c3-f5a82df32191',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3185,
      y: 651,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9237d12a-b7d9-4ccf-8cee-cfec4a88b6b7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3066,
      y: 596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '159fbc92-775e-4a4e-b3df-3ac3a313dbb6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3482,
      y: 616,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '10ceb1f4-bfd9-4f99-941e-5229e3cf49c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3379,
      y: 646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '1c7b757d-529b-47a6-afb4-8442c7bfb789',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3278,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '87b5e592-5b45-4cd1-ab33-931aac47dfeb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3177,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '1fb5d548-bd40-4cb4-80dd-c06178e904e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3079,
      y: 674,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '74f24754-8029-4e6c-ab6b-51b06c12ec7f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3594,
      y: 667,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '7190ac9e-8301-4779-94a0-23a2d1d66232',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3494,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'e698c0ed-f37a-439a-9897-282a6dfbba89',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3390,
      y: 743,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '3dfb5d31-3169-49fa-8478-899e943824c2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3301,
      y: 796,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '8f7adc9d-9951-4329-92e4-3d2eeda18943',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3614,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '7120f726-975a-4d88-ae53-14a0eab7db1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3502,
      y: 803,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '2d1dacdf-83f5-49a0-a220-9c0b93311117',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3706,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '6dc24a9a-25bd-4d29-8fe7-1d1a5d5d1fc7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3439,
      y: 57,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '40c6eea9-4dfc-4e2d-9dde-c9bfb016e2b4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3324,
      y: 87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '39cc3c36-0684-443f-a679-e870f2a3e436',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3244,
      y: 145,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'de36ff90-8e29-473e-9ffd-96921bbb3926',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3568,
      y: 103,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '2aaa9def-7e44-427b-8412-67bfff05f333',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3461,
      y: 143,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '0f758695-03ac-4e41-8ab8-e473bc114ce8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3365,
      y: 183,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '9a9b2db8-99ae-4707-978e-54fb3782d887',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3676,
      y: 142,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'cdc8a665-f6c5-48c6-9e08-e3908be73faf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3571,
      y: 183,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '3dc5cf74-ba3e-4c15-99be-8a5ffca0a07c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3479,
      y: 244,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '416416b0-d2f7-49fb-98f3-13064239eda0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3914,
      y: 241,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: 'fde6a381-a047-427c-8f50-36a5b360c092',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3806,
      y: 281,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '885df01e-24c5-441f-b9be-6d7052075a4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3719,
      y: 340,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '39ad153e-22d8-4508-be49-be3464147cd6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4017,
      y: 275,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '75c6f242-c191-4051-822e-09610931b67c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3926,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '32b308c4-eee0-4dd6-8d8d-87c86f474cf7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3843,
      y: 355,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '51bf0fa1-6bd1-4855-998b-e030042a1595',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3773,
      y: 414,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '3ead7f48-6d3b-431c-9e9e-95950c571a79',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4068,
      y: 337,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '043fd9c9-2678-4612-8327-f12e2d9a4726',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3978,
      y: 383,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '64f91626-22aa-4343-93c5-acb36f66e839',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3878,
      y: 424,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '0477a4a2-f0e9-44cd-b946-105915f8ba10',
      data: ''
    },
    {
      id: '17f0d7fd-d977-4237-8971-33f15e0cb747',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4658,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '722a13a0-adcd-4da7-aad4-05fee6552e6e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4846,
      y: 532,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: 'a12283c5-fabe-46e4-85d4-abd829f74af6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4768,
      y: 672,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '5ddb3eda-85d0-44ac-bb4a-2c44776e62a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4867,
      y: 622,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '8e666e64-7934-4762-b15c-1436b4914e0c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4945,
      y: 570,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '2a607496-2cfb-48e0-bbc7-c5e52011af24',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4886,
      y: 705,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '8ae74771-a6a4-4447-b598-38c082927334',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5002,
      y: 647,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '00379786-fe72-4819-8945-4a534af59999',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4994,
      y: 748,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e88c7933-7666-4143-b54b-b10d4b9a6d00',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5123,
      y: 688,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '1f86b818-7839-437f-a9ec-acb671201513',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4641,
      y: 431,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '335e6ba6-7936-44de-8093-1078d9fdb2df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5247,
      y: 272,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '61552374-e2cb-4f5a-bdf5-5c72b17b1daa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5342,
      y: 313,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '711300b3-93c7-40d0-a550-f2a19ae1cf2d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4643,
      y: 522,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: 'a25bad24-4543-41f8-85d1-b4f8853c1f6e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4751,
      y: 477,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '5fc52a68-ca25-429f-83dc-8d57f184dfa1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4545,
      y: 580,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '55196703-219b-48a0-9092-3cda9997ceb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5053,
      y: 269,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: 'cec536c8-baec-4b56-a7f7-008969886c44',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5139,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '6379c630-9784-4415-9a70-92bb40e54b33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5240,
      y: 360,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd1a188de-d80f-4552-84e1-36fd8e5489a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5161,
      y: 221,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '0400749d-561d-4f49-86d0-aa174c0d6466',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4544,
      y: 482,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '54eb9005-98cf-4456-847f-0a5033b5792f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4440,
      y: 536,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_4',
      parent: '185',
      data: ''
    },
    {
      id: '5c24d919-2a93-4d40-a986-ff665c19b0a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6337,
      y: 540,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '778e555a-96e5-459e-9edb-3f7352cb49cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6055,
      y: 615,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '2d766807-1cbc-4391-a529-659ef0f32f67',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5942,
      y: 437,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'fc022931-8641-4b5a-9b04-be068f3847f6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5910,
      y: 601,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '48781ab3-cc6b-4786-aa19-be8ddcf036c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5771,
      y: 579,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'c4b6f30e-30fa-4e67-a311-654b849d8e39',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5771,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '3d55067d-0bcd-4126-ab1c-120ee4964ba7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5922,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '3ccc54a2-9e8b-465d-a55b-7103c600d13d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6109,
      y: 758,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'd7590692-771f-40b3-ad98-453bea1cb7b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6071,
      y: 478,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '86b42e40-3c9e-40db-abb1-400f333637b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6210,
      y: 458,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '1a5c01da-8a13-4647-9418-c958a6cb6440',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6222,
      y: 605,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '0a7a26f2-4ceb-4c55-befe-e23b350d8c5d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6242,
      y: 750,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: '40d2a4d4-33e3-4eaf-84a7-ea1c09ca26d6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6387,
      y: 698,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: 'cf4113c1-90b8-4bd4-968b-148bcd278484',
      data: ''
    },
    {
      id: 'd95b942e-8b33-4a0f-9378-d3842c756321',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7180,
      y: 476,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b261d999-ee9d-4ebc-8ce7-5c4a2659af67',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7022,
      y: 501,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '476ae968-03a9-474d-a816-7ac3b55c8c2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7088,
      y: 358,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b3bd24e8-218a-4fe1-843d-0e26ce5d369e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7254,
      y: 254,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '9bc33fdc-e487-4a8c-af58-0eb68c2d2d49',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7108,
      y: 208,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '9e2185b7-57cb-430a-9636-eafe3d007c45',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6964,
      y: 268,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '33ac7ac5-735b-40a0-9501-a9d0e2c9dd05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6896,
      y: 407,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f662e650-535a-4a72-8dfc-529a9e51756c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6835,
      y: 170,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '3adc2f9a-a773-4518-bff6-6586ec62b4da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6799,
      y: 314,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '29604e55-6658-4294-8fa3-6e5e72d24931',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7729,
      y: 575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'e3008d40-bb76-4cbb-9a77-96ab66010e86',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7851,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'd9cb7eb9-9cf4-4c1e-a428-de63717277a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7664,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '881c7db7-a7b0-442b-a0a7-075dbbf17b66',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7490,
      y: 722,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: '647b29a3-3bd2-44fd-b4a3-4379a23dc2e4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7570,
      y: 560,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'dd19641b-49c4-4282-9f81-93263d6fa40c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7318,
      y: 706,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a6c45644-b20b-4019-b0a0-69abdd2d5d22',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8333,
      y: 681,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '2f30fad2-1e95-461d-a798-674c642d4f4e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8246,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'adb1a197-b963-4016-ad7a-f0f5eb1a5ab6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8158,
      y: 696,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '2dc16bcf-91a6-430e-8670-e496ed889897',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8068,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '4c270314-dd44-41c8-bbf6-a3694ebc3aad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8467,
      y: 696,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '38c4094d-a5d4-48ad-80fc-bfa655b5c1ef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8391,
      y: 740,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '0d6fb0ab-48a8-434e-8d0e-3cb5bbe73715',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8606,
      y: 716,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '3e2e18b8-a18f-45f4-83ae-daaddaa66db4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8536,
      y: 748,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'b34346e2-6081-4765-87f5-d2a4adf2788f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9017,
      y: 557,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '5e4852a8-def3-484a-b599-473f074159a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9106,
      y: 501,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c6a17506-6f24-46af-9c4d-b13ee4bd4f72',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9202,
      y: 452,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '4971f5e1-a460-4e9e-ba1b-14cf5dd71552',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9156,
      y: 637,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '96b1af37-d4cc-48c6-bd43-7d982a393187',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9245,
      y: 595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '2db9f95a-c604-47b6-b4f6-8d22be62ca58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9351,
      y: 550,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'e0b0a81f-57b4-4157-937b-d39b59adffb7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9066,
      y: 618,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd481bcc7-d0a3-4a4c-b044-c90e6190ea8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9171,
      y: 544,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '1ae3b92a-f5c1-4e9f-b10a-d1aadf4eb437',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8419,
      y: 186,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '44201b02-022d-4573-9951-1e5b2e1a4adc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8536,
      y: 144,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'feea7c4c-dcb4-441a-8f7a-5cb02e71c8bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8432,
      y: 90,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '447b70a8-fe95-4159-8f4b-47c5431061c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8332,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'fc01cedc-335d-4232-b922-302d97a6d180',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8221,
      y: 169,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c9b2200b-3ab1-42b7-a17e-e549a1b0b7ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8115,
      y: 91,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '3a1e79dc-b27c-4750-bf2d-9478adbb546f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8233,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'aa6befa2-0ea6-4aa6-a439-1ac9cadec950',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8896,
      y: 184,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f36698e3-16a3-4929-b625-3bbf0e45361c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8804,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '9c4ef57f-fcea-49fa-a235-c797cecbb41e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8723,
      y: 65,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ca9426ac-1bdb-454c-84e8-819de627e2d0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8917,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '9508657f-b175-4823-bfd9-7af596a426a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8827,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ebb43c5c-5fa2-4a10-ae89-610cb95912a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9056,
      y: 132,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '3d2d729e-20e6-44db-9b80-1820a0aae6e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9188,
      y: 126,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '61feb554-d15d-4f22-881a-8c9c031bec3a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9101,
      y: 73,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '93d4cee3-e903-49ae-8556-82cd123b0634',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9281,
      y: 105,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '2fcf3632-068c-4622-9ee0-d634864ffc04',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9176,
      y: 47,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '73b6abba-0e86-4fc7-b9e6-928c64a9df4d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9328,
      y: 51,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '06166729-af71-494e-a696-3006cdc244e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8973,
      y: 67,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '22b7eb30-4008-4d16-930b-15450a08714f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8295,
      y: 233,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '04f89141-01c7-43e6-8d32-3c9cbe96eba9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9273,
      y: 489,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '25b07ba9-c36b-46ea-9b39-faa663ff5837',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8516,
      y: 228,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: '95c58c6e-54c1-4be1-b6ac-ee04c35e5e1a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8402,
      y: 268,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c9057961-313f-4aba-8d06-2b8f9c958b90',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9359,
      y: 806,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b73ef8f8-11b5-44f0-87e7-f6270a339a3f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9893,
      y: 162,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '382e5501-ccef-42d0-ae7e-b6e9887c7412',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10079,
      y: 278,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2f1ff0bc-55f3-4a8e-a950-e8a89ca2afd9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10221,
      y: 310,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '4edceaa7-215f-400b-8f25-c554ca6e23cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10196,
      y: 391,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '05a32f1c-b0c4-4679-af3d-3faad0c2ff32',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10110,
      y: 346,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'ed02c270-c484-403d-ac3f-12e9de42491a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10006,
      y: 382,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '77e952c0-4dea-4d71-81a7-7ac85750f330',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9981,
      y: 307,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '3e5ccbb2-e3a1-43c0-bbc1-57443d54f230',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9883,
      y: 355,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '903331a8-0a59-4d68-920d-387efae5c74f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9889,
      y: 253,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'ee74d50e-8d07-4218-9199-13eb43a20e3a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9791,
      y: 300,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b9ddf822-0e00-4398-9d6c-11160f882884',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9783,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '6a62a44d-29e3-4e68-8ea6-c7fcbecc3020',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9688,
      y: 239,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'bac19ea8-a11e-4b07-8808-1b00ea998828',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9913,
      y: 779,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2adb248a-0230-41e6-9aa4-d6630f9841f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9768,
      y: 719,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '364dff65-10d8-4006-974d-db0e5a0e2b56',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9669,
      y: 781,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '89ec698b-9629-4d13-8cfb-6382f2787b33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9593,
      y: 701,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2f2de1d0-e9ec-4e92-be32-6d27bdc92382',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9508,
      y: 777,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '6b41c8f5-95ac-4964-a472-f02531b22c4e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9517,
      y: 666,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '0df63649-b3b0-4ab5-b424-25caed2339e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9421,
      y: 720,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.75,
        y: 0.75
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 739,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2073,
      y: 467,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3594,
      y: 233,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '631194d4-ad73-4366-a65f-21797e8dc249',
      data: ''
    },
    {
      id: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4759,
      y: 521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: 'af38acd5-a0e4-43d7-856f-fef8f3b120a3',
      data: ''
    },
    {
      id: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6445,
      y: 224,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '74092e03-0544-42a0-a499-3278f19873a5',
      data: ''
    },
    {
      id: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7275,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '583acaed-3914-470b-a17f-69f0e67d92ab',
      data: ''
    },
    {
      id: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8463,
      y: 385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: 'ea7f8b33-ad80-48d6-98f7-0540c1ec4100',
      data: ''
    },
    {
      id: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9862,
      y: 416,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '214ea0e2-d913-4c42-a718-1f4bc72d2b79',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'berseem_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '5e0141b9-e88c-4195-9c3a-41026c2f0f02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      data: ''
    },
    {
      id: 'eac7b762-4daa-4f48-a00f-fa9842083630',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_harvest_map',
      parent: '783bfbfa-2df6-42cc-bf84-76fd51e78608',
      data: ''
    },
    {
      id: '1c1c11b6-3bec-42ac-9ba7-734666ce9f9e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      data: ''
    },
    {
      id: 'd1659629-b52b-4f7a-9540-f46fdd47b041',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'pricklypears_harvest_map',
      parent: '30b690e8-10f3-4a7d-93fa-49e848ea29a0',
      data: ''
    },
    {
      id: 'c0951141-6c84-4809-9f82-95dafdb20791',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      data: ''
    },
    {
      id: '9b6a42ce-3523-4770-bb25-bf8564dbb68a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_harvest_map',
      parent: '3301b21a-1a83-49c0-b4b3-510b06170ae2',
      data: ''
    },
    {
      id: 'eebc8c9c-a331-443b-916c-21e0b62c9e5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      data: ''
    },
    {
      id: '37c498a2-2982-4a27-ab11-ad78a4d1b579',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loquat_harvest_map',
      parent: '73700aea-a9ff-4f9b-a1c8-b501ac51b365',
      data: ''
    },
    {
      id: '58315196-25c5-41cf-b5b5-2686aef5cf8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      data: ''
    },
    {
      id: 'd042d300-813b-485a-9131-9c87b3fd752e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_harvest_map',
      parent: 'b6033e03-6579-4338-9f74-96c6457dd0e1',
      data: ''
    },
    {
      id: '02371518-93f5-4aa0-9cbf-601b79c46a84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      data: ''
    },
    {
      id: 'a0c529bc-64cb-4fdf-b45c-523b7628ab68',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'papyrus_harvest_map',
      parent: '0fb04e12-f31f-4953-87bb-795798c81ab1',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout28 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
